var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgUae(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 19,
    height: 19,
    viewBox: "0 0 19 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1493_1071)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M16.936 3H5.43604V7.5H18.936V5C18.936 4.46957 18.7253 3.96086 18.3502 3.58579C17.9752 3.21071 17.4665 3 16.936 3Z",
    fill: "#068241"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.43604 7.5H18.936V11.5H5.43604V7.5Z",
    fill: "#EEEEEE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.43604 16H16.936C17.4665 16 17.9752 15.7893 18.3502 15.4142C18.7253 15.0391 18.936 14.5304 18.936 14V11.5H5.43604V16Z",
    fill: "#141414"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2.93604 3C2.4056 3 1.89689 3.21071 1.52182 3.58579C1.14675 3.96086 0.936035 4.46957 0.936035 5L0.936035 14C0.936035 14.5304 1.14675 15.0391 1.52182 15.4142C1.89689 15.7893 2.4056 16 2.93604 16H5.43604V3H2.93604Z",
    fill: "#EC2028"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1493_1071"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 18,
    height: 18,
    fill: "white",
    transform: "translate(0.936035 0.5)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUae);
export default __webpack_public_path__ + "static/media/uae.752c3e938c3268ef5a9959798caba6ad.svg";
export { ForwardRef as ReactComponent };